import { render, staticRenderFns } from "./ViewTrade.vue?vue&type=template&id=15715334&scoped=true&"
import script from "./ViewTrade.vue?vue&type=script&lang=js&"
export * from "./ViewTrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15715334",
  null
  
)

export default component.exports